import {
  formatCurrencyInput,
  normalizeCurrencyInput,
} from "../formatters/currency";

export function CurrencyInput({
  value,
  onChange,
  required = false,
  placeholder,
}: {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
}) {
  return (
    <div className="money-input">
      <span aria-hidden="true">$</span>
      <input
        required={required}
        inputMode="decimal"
        type="text"
        value={formatCurrencyInput(value)}
        onChange={(event) =>
          onChange(normalizeCurrencyInput(event.target.value))
        }
        placeholder={placeholder}
      />
    </div>
  );
}
